import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CredentialsContext } from "../../pages/credentials/CredentialsContext";
import { Therapist, Center, TherapistCredentialStatus, BCBATherapist } from "../../utils/Definitions";
import { GlobalContext } from "../../utils/GlobalContext";
import { ModalNotification } from "../ModalNotification";
import { apiConfig, loginRequest } from "../../authConfig";



interface Props {
    Therapist: BCBATherapist,
    SetProfilePictureModalActive: React.Dispatch<React.SetStateAction<boolean>>,
    SetSelectedTherapistForModal: React.Dispatch<React.SetStateAction<Therapist | null>>,
    SetCredentialsModalActive: React.Dispatch<React.SetStateAction<boolean>>,
    centers: Center[] | undefined,
    isRBT: boolean,
}

export const CredentialsTherapistCard: React.FC<Props> = (props) => {
    const navigate = useNavigate();
    const credentialsContext = useContext(CredentialsContext);

    function NavigateBCBACredentials() {
        credentialsContext.setIsRBT(props.isRBT);
        credentialsContext.setSelectedTherapist(props.Therapist);
        navigate("/credentials/bcbacredentials");
    }

    const fullyCredentialedCenters =
        props.centers && props.Therapist.credentialedCenters?.length
            ? props.Therapist.credentialedCenters
                .map(id => props.centers?.find(c => c.centerId === id)?.centerName)
                .filter(Boolean)
            : [];

    return (
        <div
            onClick={NavigateBCBACredentials}
            className="group w-full rounded-lg border bg-white p-5 shadow-sm transition
                 hover:bg-gray-50 hover:shadow-md cursor-pointer"
        >
            {/* Header */}
            <div className="mb-4">
                <h2 className="text-lg font-semibold text-gray-900">
                    {props.Therapist.employeeName}
                </h2>
                <p className="text-sm text-gray-500">
                    {props.Therapist.jobTitle}
                </p>
            </div>

            {/* Details */}
            <div className="grid grid-cols-1 gap-4 text-sm sm:grid-cols-2">
                {/* Credentialed Centers */}
                <div className="sm:col-span-2">
                    <span className="block font-medium text-gray-600 mb-1">
                        Fully Credentialed Centers
                    </span>

                    {fullyCredentialedCenters.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                            {fullyCredentialedCenters.map((center, index) => (
                                <span
                                    key={index}
                                    className="rounded-full bg-lacblue-50 px-3 py-1 text-xs font-medium text-lacblue"
                                >
                                    {center}
                                </span>
                            ))}
                        </div>
                    ) : (
                        <span className="text-gray-400 italic">None</span>
                    )}
                </div>

                {/* Re-Cert Date */}
                <div>
                    <span className="block font-medium text-gray-600">
                        Re-Cert Date
                    </span>
                    <span className="block text-gray-800">
                        {props.Therapist.bcbarecertDate
                            ? new Date(props.Therapist.bcbarecertDate).toLocaleDateString()
                            : "N/A"}
                    </span>
                </div>
            </div>
        </div>
    );
};

